import { Injectable } from '@angular/core';
import { GetApplicationResponseModel } from '../models/applications.model';
import { GetLeadResponseModel } from '../models/lead.model';

@Injectable()
export class PersonalInfoService {
  private _firstname = '';
  private _lastname = '';
  private _email = '';

  get firstName(): string {
    return this._firstname;
  }

  set firstName(value: string) {
    this._firstname = value;
  }

  get lastname(): string {
    return this._lastname;
  }

  set lastname(value: string) {
    this._lastname = value;
  }

  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }

  public populatePersonalInfo(data: GetApplicationResponseModel): void {
    this.firstName = (data?.contacts && data?.contacts[0]?.firstname) || '';
    this.lastname = (data?.contacts && data?.contacts[0]?.lastname) || '';
    this.email = (data?.contacts && data?.contacts[0]?.email) || '';
  }

  public populatePersonalInfoWithGetLeadResponseData(data: GetLeadResponseModel): void {
    this.email = data?.email;
  }
}
